export default function initializeSubMunu() {
    initializeMenu();
}

function initializeMenu() {
    const arrows = document.querySelectorAll('.sidebar-categories__item--has-children .sidebar-categories__arrow');


    if (!arrows) {
        return;
    }

    // Знаходимо всі стрілки, які мають підменю

    arrows.forEach(arrow => {
        arrow.addEventListener('click', function (e) {
            e.preventDefault();

            const item = arrow.closest('.sidebar-categories__item');
            const submenu = item.querySelector('.sidebar-categories__submenu');

            if (!submenu) return;

            const isOpen = arrow.classList.contains('sidebar-categories__arrow-open');

            if (isOpen) {
                // Закриваємо
                arrow.classList.remove('sidebar-categories__arrow-open');
                submenu.classList.remove('sidebar-categories__submenu--current');
                item.classList.remove('sidebar-categories__item--open');
            } else {
                // Відкриваємо
                arrow.classList.add('sidebar-categories__arrow-open');
                submenu.classList.add('sidebar-categories__submenu--current');
                item.classList.add('sidebar-categories__item--open');
            }
        });
    });


}